// extracted by mini-css-extract-plugin
export default {"headerContent":"styles_headerContent__RkD9N","btnContainer":"styles_btnContainer__6FVGj"};